import {
	TIME_ZONE_GET_FAIL,
	TIME_ZONE_GET_SUCCESS,
	TIME_ZONE_GET_REQUEST,
} from '../constants/timeZoneConstants';

export const timeZoneReducer = (state = { timeZoneData: null }, action) => {
	switch (action.type) {
		case TIME_ZONE_GET_REQUEST:
			return {
				...state,
				loading: true,
			};

		case TIME_ZONE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				timeZoneData: action.payload,
			};
		case TIME_ZONE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
